import { Component } from '@angular/core';
import { MaintenanceService } from './maintenance.service';

import { NbAlertModule } from '@nebular/theme';

@Component({
  selector: 'app-maintenance-banner',
  templateUrl: './maintenance-banner.component.html',
  styleUrls: ['./maintenance-banner.component.scss'],
  imports: [NbAlertModule],
})
export class MaintenanceBannerComponent {
  maintenanceMessage?: string;

  constructor(private maintenanceService: MaintenanceService) {
    this.maintenanceService
      .getMaintenanceMessage()
      .subscribe((maintenanceMessage) => {
        this.maintenanceMessage = maintenanceMessage;
      });
  }
}
